<template>
  <Modal
    :title="$t('edit_store')"
    modalId="edit-modal"
    @submit="updateStore"
  >
    <form @submit.prevent="updateStore">
      <div class="mb-3">
        <label class="form-label">{{ $t('store_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="stores.name"
          class="form-control"
        />
        <!-- Error for store -->
        <div v-if="errors.name" class="text-danger mt-2">
          <span>{{ errors.name }}</span>
        </div>

        <label class="form-label">{{ $t('store_address') }} </label>
        <input
          type="text"
          v-model="stores.address"
          class="form-control"
        />
        <!-- Error for store -->
        <div v-if="errors.address" class="text-danger mt-2">
          <span>{{ errors.address }}</span>
        </div>

        <label class="form-label">{{ $t('store_phone_number') }} </label>
        <input
          type="text"
          v-model="stores.phone_number"
          class="form-control"
        />
        <!-- Error for store -->
        <div v-if="errors.phone_number" class="text-danger mt-2">
          <span>{{ errors.phone_number }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedStore: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      stores: {
        id: null,
        name: '',
        address: '',
        phone_number: '',
      },
      errorMessage: '',  // General error message (if any)
      errors: {},        // For storing individual field errors
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  watch: {
    selectedStore: {
      immediate: true,
      handler(newStore) {
        if (newStore && newStore.id) {
          this.stores = { ...newStore };
        }
      },
    },
  },
  methods: {
    async updateStore() {
      this.errors = {};  // Reset errors
      this.errorMessage = "";  // Reset general error message

      // Frontend validation
      if (!this.stores.name.trim()) this.errors.name = "Store name is required.";

      // Address is optional, trim it only if it's a string and not null/undefined
      if (this.stores.address && typeof this.stores.address === 'string') {
        this.stores.address = this.stores.address.trim();
      } else {
        this.stores.address = '';
      }

      // Phone number is optional but should be valid if entered
      if (this.stores.phone_number && this.stores.phone_number.trim()) {
        const phoneRegex = /^[0-9]{10,15}$/;
        if (!phoneRegex.test(this.stores.phone_number.trim())) {
          this.errors.phone_number = "Enter a valid phone number (10-15 digits).";
        }
      } else {
        this.stores.phone_number = '';
      }

      if (Object.keys(this.errors).length > 0) return; // Stop if validation fails

      try {
        const response = await this.$axios.patch(
            apiUrls.inventory_store.update.replace(':pk', this.stores.id),
            {
              name: this.stores.name.trim(),
              address: this.stores.address.trim() || null,
              phone_number: this.stores.phone_number.trim() || null,
            }
        );

        this.toast.success('Store successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
         if (error.response?.data?.errors) {
          this.errors = { ...error.response.data.errors };
        } else if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        } else {
          this.errorMessage = "An unexpected error occurred. Please try again.";
        }
      }
    },
    resetForm() {
      this.stores = { id: null, name: '', address: '', phone_number: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>
